import { render, staticRenderFns } from "./ClientsCreateEdit.vue?vue&type=template&id=6ef0dbb8"
import script from "./ClientsCreateEdit.vue?vue&type=script&lang=js"
export * from "./ClientsCreateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports